import { ActionButton, CudaDialogTitle, LoadingDialogContent } from 'common/components/CudaDialog'

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import { Field } from 'redux-form'
import Grid from '@material-ui/core/Grid';
import React from 'react';
import { renderTextField } from 'common/form/fields'
import validator from 'common/form/validator'
import { withStyles } from '@material-ui/core/styles';

const style = {
    root: {
        '& input, textarea': {
            width: '100%',
        }
    },
    fieldLabel: {
        display: 'flex',
        alignItems: 'center'
    },
    errorLabel: {
        fontSize: 12,
        color: '#DD1E31',
        padding: "3px 0px 0px 3px",
        minHeight: '18px'
    },
}

// const validateTimeout = value => validator.required(value) || validator.maxValue(1800)(value);
const validateRequired = value => validator.required(value);

const SecondaryAppDialog = ({ 
    classes, isOpen, loading, submitting,
    close,
    handleSubmit,
    error,
    isLoading
    }) => {

    return (
        <form onSubmit={handleSubmit}>
            <Dialog open={isOpen} transitionDuration={0} maxWidth="md" onClose={close} className={classes.root}>
                <CudaDialogTitle onRequestClose={close}>
                Make Application Secondary
                </CudaDialogTitle>
                <LoadingDialogContent loading={loading || submitting}>
                    <Grid container alignItems='center'>

                        <Grid item xs={6} className={classes.fieldLabel}>
                        Primary Application id:
                        </Grid>

                        <Grid item xs={6}>
                            <Field
                                name="primary_app_id"
                                component={renderTextField}
                                className={classes.input}
                                validate={validateRequired}
                                autoFocus
                            />
                        </Grid>

                        <Grid item xs={6} className={classes.fieldLabel}>
                        Content Rule Domain:
                        </Grid>
                        <Grid item xs={6}>
                            <Field
                                name="cr_domain"
                                component={renderTextField}
                                className={classes.input}
                                validate={validateRequired}
                            />
                        </Grid>

                        <Grid item xs={6} className={classes.fieldLabel}>
                        Content Rule URL:
                        </Grid>
                        <Grid item xs={6}>
                            <Field
                                name="cr_url_match"
                                component={renderTextField}
                                className={classes.input}
                                validate={validateRequired}
                            />
                        </Grid>

                        <Grid item xs={6} className={classes.fieldLabel}>
                        Content Rule Extended Match:
                        </Grid>
                        <Grid item xs={6}>
                            <Field
                                name="cr_extended_match"
                                component={renderTextField}
                                className={classes.input}
                                validate={validateRequired}
                            />
                        </Grid>

                        <Grid item xs={6} className={classes.fieldLabel}>
                        Content Rule Extended Match Sequence:
                        </Grid>
                        <Grid item xs={6}>
                            <Field
                                name="cr_priority"
                                component={renderTextField}
                                className={classes.input}
                                validate={validateRequired}
                            />
                        </Grid>

                        <Grid item xs={6} className={classes.fieldLabel}>
                        Content Rule Ports:
                        </Grid>
                        <Grid item xs={6}>
                            <Field
                                name="cr_ports"
                                component={renderTextField}
                                className={classes.input}
                            />
                        </Grid>
                    </Grid>
                </LoadingDialogContent>
                <DialogActions>
                    {error &&
                        <Grid item xs={12} className={classes.errorLabel}>
                            {error}
                        </Grid>
                    }
                    <ActionButton onClick={close}>
                        Cancel
                    </ActionButton>
                    <ActionButton color="primary" onClick={handleSubmit}>
                        Save
                    </ActionButton>
                </DialogActions>

            </Dialog>
        </form>
    );
};

export default withStyles(style, { name: 'secondaryAppDialog' })(SecondaryAppDialog);